import React from 'react'
import TableItem from "./TableItem"

function TableBody(props) {
    const {error, userTransaction} = props

    return (
        <tbody className="TableBody">
        {
            !!userTransaction && userTransaction.length > 0 ? userTransaction.map((item, index) => (
                <TableItem key={index} item={item}/>
            )) : <tr className="NoRecord">
                <td colSpan={6}>Không có bản ghi nào</td>
            </tr>
        }
        {
            !!error && error.length > 0 && <tr className="NoRecord Error">
                <td colSpan={6}>{error}</td>
            </tr>
        }
        </tbody>
    )
}

export default TableBody
